import * as z from 'zod/mini';

/**
 * Schema for validating cross-tab broadcast messages.
 */
export const CrossTabBroadcastMessageSchema = z.object({
  args: z.optional(z.unknown()),
  event: z.string(),
});
